<template>
    <div class="wrap" data-testid="block-page">

        <br>
        <br>
        <br>
        <div class="row">
            <div class="col text-center">
                <i class="bi bi-bricks luna-color" style="font-size: 200px;"></i>
            </div>
        </div>
        <br>
        <div class="row">
            <div class="col text-center luna-color" style="font-size:25px;">
                このユーザーには<br>ブロックor通報されており、<br>プロフィール表示ができません。
            </div>
        </div>
        <br>
        <br>
        <div class="row">
            <div class="col text-center">
                <a href="/search" type="button" class="btn btn-luna" style="font-size: 14px; padding: 5px 30px">
                    さがすへ戻る
                </a>
            </div>
        </div>
    </div>
</template>

<script>
import { clearPageStorage } from '../event-log/clearPageStorage';

export default {
    data() {
        return {
        };
    },
    mounted() {
        clearPageStorage()
    },
}
</script>
